import { combineEpics } from 'redux-observable';
import { filter, ignoreElements, tap } from 'rxjs';
import { isOfType } from 'typesafe-actions';
import { createEpic$ } from 'lib/store';
import { NotificationAction } from './actions';

const errorNotificationEpic$ = createEpic$(({ action$, notification$ }) =>
  action$.pipe(
    filter(isOfType(NotificationAction.Error)),
    tap(action =>
      notification$.next({
        ...action.payload,
        severity: 'error',
      }),
    ),
    ignoreElements(),
  ),
);

const infoNotificationEpic$ = createEpic$(({ action$, notification$ }) =>
  action$.pipe(
    filter(isOfType(NotificationAction.Information)),
    tap(action =>
      notification$.next({
        ...action.payload,
        severity: 'info',
      }),
    ),
    ignoreElements(),
  ),
);

const successNotificationEpic$ = createEpic$(({ action$, notification$ }) =>
  action$.pipe(
    filter(isOfType(NotificationAction.Success)),
    tap(action =>
      notification$.next({
        ...action.payload,
        severity: 'success',
      }),
    ),
    ignoreElements(),
  ),
);

const warningNotificationEpic$ = createEpic$(({ action$, notification$ }) =>
  action$.pipe(
    filter(isOfType(NotificationAction.Warning)),
    tap(action =>
      notification$.next({
        ...action.payload,
        severity: 'warning',
      }),
    ),
    ignoreElements(),
  ),
);

export default combineEpics(
  errorNotificationEpic$,
  infoNotificationEpic$,
  successNotificationEpic$,
  warningNotificationEpic$,
);
